namespace Matrix.Data {
    export interface DocumentStoreRow {
        DocumentId?: string;
        Name?: string;
        DocumentType?: string;
        Content?: number[];
        DocumentUpload?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        Path?: string;
    }

    export namespace DocumentStoreRow {
        export const idProperty = 'DocumentId';
        export const nameProperty = 'DocumentId';
        export const localTextPrefix = 'Data.DocumentStore';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            DocumentId = "DocumentId",
            Name = "Name",
            DocumentType = "DocumentType",
            Content = "Content",
            DocumentUpload = "DocumentUpload",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            Path = "Path"
        }
    }
}
